import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Nendaz",
    desc: "Pose de carrelage à Nendaz pour appartements de ski, chalets familiaux et résidences de vacances. On s'adapte aux contraintes de montagne.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Nendaz",
    desc: "Rénovation de salle de bain à Nendaz. Douche, baignoire, mobilier, éclairage — on repense l'espace pour qu'il soit fonctionnel et chaleureux après une journée de ski.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Nendaz",
    desc: "Douche italienne à Nendaz. Receveur encastré, paroi vitrée, carrelage antidérapant. Pratique après une journée de ski, et jolie à regarder toute l'année.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Nendaz",
    desc: "Faïence et mosaïque à Nendaz. Des cuisines montagnardes et des salles de bain chaleureuses, avec des matériaux choisis pour leur solidité et leur esthétique.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Nendaz",
    desc: "Terrasses et balcons à Nendaz. Carrelage antidérapant, résistant au gel et aux UV, pour profiter de la vue sur les Alpes sans risque de glissade.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Nendaz",
      "item": "https://carreaux-bat.ch/nendaz"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Nendaz, Valais",
  "description": "Pose de carrelage et rénovation de salle de bain à Nendaz, station familiale des 4 Vallées. Chalets, appartements de vacances, douche italienne. Artisan carreleur.",
  "url": "https://carreaux-bat.ch/nendaz",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "areaServed": {
      "@type": "City",
      "name": "Nendaz",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function NendazPage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Nendaz à Proximité | 4 Vallées Valais"
        description="Vous cherchez un carreleur à proximité de Nendaz ? Entreprise de carrelage et société de carrelage à Nendaz, Valais. Service de carrelage par carreleur près de chez vous à Nendaz, Haute-Nendaz, Basse-Nendaz, Sornard, Saclentse. Pose de carrelage, douche italienne, faïence, terrasse. Devis gratuit."
        keywords="carreleur à proximité de Nendaz, entreprise de carrelage à proximité de Nendaz, société de carrelage à proximité de Nendaz, carreleur près de chez moi Nendaz, entreprise de carrelage près de chez vous Nendaz, service de carrelage à proximité Nendaz, entreprise de carrelage Nendaz, société de carrelage Nendaz, service de carrelage Nendaz, carreleur Nendaz, pose de carrelage Nendaz, rénovation salle de bain Nendaz, douche italienne Nendaz, carrelage chalet 4 Vallées, faïence Nendaz Valais, artisan carreleur montagne"
        canonical="https://carreaux-bat.ch/nendaz"
        ogTitle="Carrelage & Rénovation à Nendaz à Proximité — Artisan Carreleur en Station"
        ogDescription="Vous cherchez un carreleur à proximité de Nendaz ? Pose de carrelage, rénovation salle de bain et douche italienne à Nendaz et dans les hameaux des 4 Vallées. Chalets et appartements de montagne."
        ogImage="/images/nendaz-hero.jpg"
        geoPosition="46.1833;7.3000"
        geoPlacename="Nendaz, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/nendaz-hero.jpg"
          alt="Carrelage Nendaz Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Les 4 Vallées
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Nendaz</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            Nendaz, c'est le Valais authentique. On travaille ici sur des chalets familiaux, des appartements de vacances, des vieilles bâtisses qu'il faut rénover avec respect.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Nendaz</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Nendaz, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Nendaz, l&apos;authenticité des 4 Vallées</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Nendaz est une commune de montagne située à 1 250 mètres d&apos;altitude dans le canton du Valais, au cœur du domaine des 4 Vallées. Avec environ 6 000 habitants permanents, Nendaz est une station familiale qui a su préserver son authenticité villageoise tout en offrant un accès direct à l&apos;un des plus grands domaines skiables du monde.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Carreleur à Nendaz — Pose de carrelage pour chalets et appartements</h3>
                <p>
                  Le village de Nendaz est construit en amphithéâtre sur les hauteurs de la rive gauche du Rhône, offrant une vue panoramique exceptionnelle sur la vallée et les sommets environnants. Les chalets traditionnels en bois, les ruelles pavées et les fontaines villageoises créent une atmosphère chaleureuse et authentique qui contraste avec les grandes stations plus commerciales. Le secteur de Haute-Nendaz, plus récent, propose des appartements modernes avec accès direct aux remontées mécaniques.
                </p>
                <p>
                  Nendaz est réputée pour son vaste réseau de bisses, ces canaux d&apos;irrigation historiques qui serpentent à travers les forêts et les alpages. Le Bisse de Saxon, le Bisse du Milieu et le Bisse de Choulex offrent des balades bucoliques spectaculaires qui font le bonheur des randonneurs en été. La commune est également un paradis pour les amateurs de VTT et de trail, avec des sentiers balisés qui sillonnent les montagnes.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Nendaz — Rénovation salle de bain et douche italienne</h3>
                <p>
                  Sur le plan immobilier, Nendaz présente une grande diversité. Les vieux chalets du village nécessitent souvent une rénovation complète des salles de bain et des cuisines pour répondre aux normes modernes tout en préservant le charme rustique. Les appartements des résidences récentes demandent des finitions design et des matériaux durables pour résister à l&apos;intensité de la location saisonnière.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Société de carrelage à Nendaz et dans les hameaux des 4 Vallées</h3>
                <p>
                  Notre équipe intervient à Nendaz et dans les hameaux environnants : Haute-Nendaz, Basse-Nendaz, Sornard, Saclentse. On connaît les contraintes des constructions de montagne : accès par des chemins enneigés, livraison de matériaux en altitude, et finitions qui doivent résister au froid et à l&apos;humidité. Envoyez-nous un message, on vient vous voir.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/nendaz-realisation.jpg"
                  alt="Réalisation carrelage Nendaz"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">6 000</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants à Nendaz</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1250 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">48h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Gratuit</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur place</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Nendaz</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis gratuit à Nendaz</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message, on monte à Nendaz et dans les hameaux des 4 Vallées. On regarde votre espace, on discute, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Nendaz</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            De Haute-Nendaz à Saclentse, on connaît les chemins enneigés et les accès compliqués. On s'adapte : on monte les matériaux en hauteur, on travaille dans des espaces parfois exigus, et on livre un boulot qui tient face aux hivers valaisans.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit à Nendaz
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Nendaz"
        faqs={[
          {
            question: "Travaillez-vous dans les chalets traditionnels de Nendaz ?",
            answer: "Oui, c'est un de nos projets favoris. Les chalets traditionnels de Nendaz ont une âme qu'on aime préserver. On modernise les salles de bain et les cuisines avec des matériaux chaleureux qui respectent l'esprit montagnard, tout en apportant le confort moderne."
          },
          {
            question: "Intervenez-vous à Haute-Nendaz et dans les hameaux ?",
            answer: "Oui, on intervient dans tout le domaine skiable des 4 Vallées : Nendaz, Haute-Nendaz, Basse-Nendaz, Sornard, Saclentse. On connaît les accès enneigés et les contraintes de livraison en altitude. Pas de surprise, on anticipe les difficultés logistiques."
          },
          {
            question: "Quels matériaux recommandez-vous pour les appartements de location à Nendaz ?",
            answer: "Pour les appartements de location saisonnière à Nendaz, on recommande des matériaux très résistants : grès cérame émaillé pour sa facilité d'entretien, joints époxy pour leur durabilité, et carrelages antidérapants pour les salles de bain. L'investissement initial est un peu plus élevé, mais la longévité est bien supérieure."
          },
          {
            question: "Faites-vous des douches italiennes dans les petits espaces de montagne ?",
            answer: "Absolument. Les appartements de montagne à Nendaz sont souvent compacts. On optimise chaque centimètre : receveur encastré, paroi coulissante, niche de rangement intégrée, et carrelage en grand format pour l'effet d'ampleur. Le résultat est fonctionnel et élégant, même dans 4m²."
          },
          {
            question: "Comment gérez-vous les travaux en hiver à Nendaz ?",
            answer: "On travaille toute l'année à Nendaz, mais en hiver on anticipe les contraintes : matériaux stockés au chaud avant la pose, livraisons planifiées en dehors des jours de neige, et planning flexible pour s'adapter aux conditions météo. On informe le client en temps réel de tout changement."
          },
          {
            question: "Quel est le prix d'une rénovation de salle de bain à Nendaz ?",
            answer: "Le prix dépend de la surface, des matériaux choisis et de la complexité du chantier. À Nendaz, il faut parfois ajouter des coûts logistiques pour l'accès en altitude. On fait un devis détaillé sur place qui inclut tous les postes, sans surprise. Le devis est gratuit et sans engagement."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
